import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import MainWrapper from "../../helpers/MainWrapper";
import "./styles.less";
import Campaigns from "./Campaigns";

declare var root: any;

const CampaignsPage = () => {
  return (
    <>
      <MainWrapper menus={true}>
        <Campaigns />
      </MainWrapper>
    </>
  );
};

if (root) {
  ReactDOM.render(<CampaignsPage />, root);
}
